import { SplitsLink } from '~/components/Link'
import { LearnMoreLinkProps } from '~/components/component-library/LearnMoreLink/types'

export type { LearnMoreLinkProps }

export const LearnMoreLink = ({ docsUrl }: LearnMoreLinkProps) => (
  <SplitsLink path={docsUrl} target="tab" underline>
    Learn more
  </SplitsLink>
)
